import { EmptyState, InlineAlert, TableSkeleton } from '@planuze/ui';
import { HardDrive } from 'lucide-react';
import { useReleasesAdminContent } from '../../content/sections/releases-admin.js';
import { useReleaseBucket } from '../../hooks/use-releases.js';
import { ReleaseBucketTable } from './release-bucket-table.js';

/* Painel da aba "Bucket R2" (ADR-0659/0704). Encapsula `useReleaseBucket()`: a page só monta este
   painel quando a aba está ativa (lazy), então a query do bucket não dispara no load da lista de
   releases — só quando o staff realmente abre a auditoria. Visão bruta do que já subiu no R2; o
   registro por versão continua em "Registrar release". */
export function ReleaseBucketPanel() {
  const { data, isLoading, isError } = useReleaseBucket();
  const copy = useReleasesAdminContent().bucketPanel;

  if (isError) {
    return <InlineAlert variant="destructive">{copy.loadError}</InlineAlert>;
  }
  if (isLoading) {
    return <TableSkeleton columns={2} />;
  }

  const objects = data ?? [];
  if (objects.length === 0) {
    return (
      <EmptyState
        icon={<HardDrive className="size-6" />}
        title={copy.emptyTitle}
        description={copy.emptyDescription}
      />
    );
  }

  return (
    <div className="space-y-2">
      <p className="max-w-2xl text-sm text-muted-foreground">
        {copy.auditNotePrefix} <strong>{copy.auditNoteStrong}</strong>.
      </p>
      <ReleaseBucketTable objects={objects} />
    </div>
  );
}
